import(/* webpackMode: "eager" */ "/vercel/path0/web/components/Header/Header.tsx");
import(/* webpackMode: "eager" */ "/vercel/path0/web/node_modules/@vercel/analytics/dist/react/index.mjs");
import(/* webpackMode: "eager" */ "/vercel/path0/web/styles/main.scss")